import * as React from 'react';
export const IcGlucometer = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.21 5.62s-.05-.07-.09-.09A.266.266 0 0012 5.5c-.04 0-.08.01-.12.03-.04.02-.07.05-.09.09L10.61 7.6c-.21.35-.32.74-.32 1.15 0 .46.18.91.5 1.24a1.665 1.665 0 002.4 0c.32-.33.5-.77.5-1.24 0-.41-.11-.8-.32-1.15l-1.18-1.98h.02zM16.48 2H7.53C6.69 2 6 2.68 6 3.53V10c0 2.62 1.69 4.85 4.03 5.66A2 2 0 0112 14c.99 0 1.8.72 1.97 1.66A5.984 5.984 0 0018 10V3.53C18 2.69 17.32 2 16.47 2h.01zm-.47 8.9c0 .61-.49 1.1-1.1 1.1H9.12c-.61 0-1.1-.49-1.1-1.1V5.11c0-.61.49-1.1 1.1-1.1h5.79c.61 0 1.1.49 1.1 1.1v5.79zm-4 4.1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1z'
      fill='currentColor'
    />
  </svg>
);
